import React, { useEffect } from 'react'
import { useLocation, Link } from 'react-router-dom'
import notFound from '../../assets/images/not_found.webp'
import { ROOT_URL } from "../../config/constant";


const NotFoundPage = () => {
  // const reason = params.get('reason') || 'Page not found'
  const reLoginPath = ROOT_URL; // 'https://glocal360-qa.com'
    //'https://glocal360.auth.ap-south-1.amazoncognito.com/logout?client_id=6fm0idi1dqc9seavduqd07dbj5&logout_uri=https://glocal360-qa.com'

  return (
    <div className='flex flex-col items-center justify-center min-h-screen bg-gray-100 text-center'>
      <img src={notFound} alt='Page Not Found' height='500' width='500' />

      <a
        href={reLoginPath}
        className='mt-6 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600'
      >
        Return to Dashboard
      </a>
    </div>
  )
}

export default NotFoundPage
